import request from './index'

// 通知类型维护
export function getNoticeTypes() {
  return request({
    url: '/announcements/notice-types',
    method: 'get'
  })
}

export function createNoticeType(data) {
  return request({
    url: '/announcements/notice-types',
    method: 'post',
    data
  })
}

export function updateNoticeType(id, data) {
  return request({
    url: '/announcements/notice-types/' + id,
    method: 'put',
    data
  })
}

export function deleteNoticeType(id) {
  return request({
    url: '/announcements/notice-types/' + id,
    method: 'delete'
  })
}

// 通知附件上传
export function uploadFile(file) {
  const formData = new FormData()
  formData.append('file', file)
  return request({
    url: '/announcements/upload',
    method: 'post',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function getList(params) {
  return request({
    url: '/announcements',
    method: 'get',
    params
  })
}

export function create(data) {
  return request({
    url: '/announcements',
    method: 'post',
    data
  })
}

export function update(id, data) {
  return request({
    url: '/announcements/' + id,
    method: 'put',
    data
  })
}

export function remove(id) {
  return request({
    url: '/announcements/' + id,
    method: 'delete'
  })
}

export function publish(id) {
  return request({
    url: `/announcements/${id}/publish`,
    method: 'post'
  })
}

export function revoke(id) {
  return request({
    url: `/announcements/${id}/revoke`,
    method: 'post'
  })
}

// 已读列表（员工姓名 + 读取时间）
export function getAnnouncementReads(id) {
  return request({
    url: `/announcements/${id}/reads`,
    method: 'get'
  })
}

// 公告选择指定员工下拉（在职员工）
export function getEmployeeOptions() {
  return request({
    url: '/announcements/employee-options',
    method: 'get'
  })
}

// 员工端
export function getMyAnnouncements() {
  return request({
    url: '/announcements/employee/my',
    method: 'get'
  })
}

export function getUnreadCount() {
  return request({
    url: '/announcements/employee/unread-count',
    method: 'get'
  })
}

export function markRead(id) {
  return request({
    url: `/announcements/employee/${id}/read`,
    method: 'post'
  })
}
